import type { ReactNode } from "react";
import { MoreVertical } from "lucide-react";

import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "~/shared/ui/dropdown-menu";

import { SECTION_V5 } from "./design-tokens";

export interface SectionRowContextMenuProps {
    /** Accessible label for the «three-dots» trigger (caller composes it with the entity name). */
    ariaLabel: string;
    /** Menu body — `DropdownMenuItem` / `DropdownMenuSeparator` nodes. */
    children: ReactNode;
    /** Trigger button class (defaults to the table-row token; cards pass a contrast overlay). */
    triggerClassName?: string;
}

/**
 * Generic «three-dots» row/card context menu: shadcn `DropdownMenu` +
 * `MoreVertical` trigger that stops propagation (so clicking the dots does not
 * open the row) and an `align="end"` content shell. Concrete menus supply only
 * their items via `children` and the trigger `ariaLabel`.
 */
export function SectionRowContextMenu({ ariaLabel, children, triggerClassName }: SectionRowContextMenuProps) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    aria-label={ariaLabel}
                    onClick={(e) => e.stopPropagation()}
                    className={triggerClassName ?? SECTION_V5.rowContextTrigger}
                >
                    <MoreVertical className="size-4" aria-hidden />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()} className="min-w-44">
                {children}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
